"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useAccordionPanel_unstable", {
    enumerable: true,
    get: ()=>useAccordionPanel_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _reactTabster = require("@fluentui/react-tabster");
const _index = require("../AccordionItem/index");
const _accordionContext = require("../Accordion/AccordionContext");
const useAccordionPanel_unstable = (props, ref)=>{
    const { open  } = (0, _index.useAccordionItemContext_unstable)();
    const focusableProps = (0, _reactTabster.useTabsterAttributes)({
        focusable: {
            excludeFromMover: true
        }
    });
    const navigation = (0, _accordionContext.useAccordionContext_unstable)((ctx)=>ctx.navigation);
    return {
        open,
        components: {
            root: 'div'
        },
        root: (0, _reactUtilities.getNativeElementProps)('div', {
            ref,
            ...props,
            ...navigation && focusableProps
        })
    };
}; //# sourceMappingURL=useAccordionPanel.js.map

//# sourceMappingURL=useAccordionPanel.js.map